import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/bg_static.svg")